import LoadIndicatorContainer from './LoadIndicator.container.tsx';
import LoadIndicatorContent from './LoadIndicator.content.tsx';
import { LoadIndicatorContentProps } from './LoadIndicator.content.tsx';
import style from './LoadIndicator.scss?inline';

const LoadIndicator = (props: LoadIndicatorContentProps) => (
	<LoadIndicatorContainer>
		<style>{style}</style>
		<LoadIndicatorContent {...props}></LoadIndicatorContent>
	</LoadIndicatorContainer>
);

export default LoadIndicator;
